import { Selector } from '../StoreConfig';
import { LogList } from './types';

export const selectSupplierLogs: Selector<LogList> = (state) => {
  return state.logs;
};
